import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from 'utils/yup';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { ContactRepository } from 'interfaceAdapter/repositories/Contact';
import { ContactCategoryTypes } from 'domain/valueObjects/Contact/Contact';
import { useLoading } from 'application/contexts/useLoading';

const schema = yup
    .object({
        email: yup.string().required().email('メールアドレス形式で入力してください'),
        name: yup.string().required(),
        category: yup.string().required(),
        content: yup.string().required(),
    })
    .required();

type ContactForm = yup.InferType<typeof schema>;

export const useContactForm = () => {
    const diContainer = useContext(diContainerContext);
    const contactRepository = diContainer.resolve(ContactRepository);
    const { loading, setLoading } = useLoading();
    const [complete, setComplete] = useState(false);

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<ContactForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            email: '',
            name: '',
            category: '',
            content: '',
        },
    });

    const submit = handleSubmit(async (data) => {
        setLoading(true);
        try {
            await contactRepository.post(data.email, data.name, data.category as ContactCategoryTypes, data.content);
            setComplete(true);
        } finally {
            setLoading(false);
        }
    });

    return {
        control,
        errors,
        submit,
        loading,
        complete,
    };
};
